/**
 * Strip absolute backend host from an image / file URL so it resolves against
 * the current origin instead of the Emergent-hosted backend URL. This keeps
 * customers browsing "kultopiaapparel.com" from ever seeing an
 * "*.emergent.host" or "*.emergentagent.com" URL in inspect element.
 *
 * Safe on any input: null / undefined / non-strings pass through untouched.
 * Fully-qualified 3rd-party URLs (Stripe assets, external image hosts) are
 * left alone.
 */
export function sameOriginUrl(url) {
  if (!url || typeof url !== "string") return url;
  // Already relative — nothing to do.
  if (url.startsWith("/") || url.startsWith("data:") || url.startsWith("blob:")) return url;

  try {
    const u = new URL(url);
    // Only rewrite URLs that clearly point at an Emergent-hosted backend of
    // this app. Anything else (Stripe, Google Fonts, customer CDN, etc.) is
    // preserved verbatim.
    if (/(^|\.)emergent(agent)?\.(host|com)$/i.test(u.hostname)) {
      return u.pathname + u.search + u.hash;
    }
  } catch (_e) {
    // Not a URL — return as-is.
  }
  return url;
}
